module.exports = __webpack_public_path__ + "fb477d5d69ece0737e018e952d0cbd06.mp3";